const { toString } = require('@/functions/transform');

class AppPath {
    /**
     * @param {string} path
     * @param {{}} params
     */
    constructor(path, params = {}) {
        this.path = path;
        this.params = params;
    }

    getHydrationMap() {
        return {
            path: toString,
            params: {},
        };
    }
}

module.exports = AppPath;
